import script from "./IntegrationConfigDetailsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./IntegrationConfigDetailsView.vue?vue&type=script&setup=true&lang=ts"

import "./IntegrationConfigDetailsView.vue?vue&type=style&index=0&id=3f51e5ca&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f51e5ca"]])

export default __exports__